import { gql } from 'apollo-boost';

export const UPDATE_USER_MAX_CREDITS = gql`
    mutation ($data: UpdateUserMaxCreditsInput!) {
        updateUserMaxCredits(data: $data)
    }
`;
